/* mm : added to remove koin text */

const watermarks = document.querySelectorAll('.koin-watermark');
    watermarks.forEach(function(watermark) {
        watermark.remove();
    });

/* mm : added to remove koin text */
document.addEventListener('DOMContentLoaded', function() {
  // Check if the URL doesn't contain 'for-home'
  if (!window.location.href.includes('for-home')) {
    // Find the element and hide it
    const element = document.getElementById('shopify-section-template--19458083586287__image_with_text_overlay_kLiHrG');
    if (element) {
      element.style.display = 'none';
    }
  }
}); 

console.log('custom...')